import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { getClassName, THEMES } from '../../utils'

import './listEditable.component.scss'

/**
 * Editable List Component
 */
class ListEditable extends PureComponent {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { listKey, iconTheme, icon, items, onDelete } = this.props

    return (
      <div className='list-editable'>
        {(items || []).map((item, index) => {
          if (!item) {
            return null
          }

          const { label } = item

          return (
            <div key={item[listKey] || index} className='list-editable_item'>
              <div className='list-editable_item-content'>
                {icon ? <i className={getClassName('list-editable_item-icon', [
                  { condition: icon, trueClassName: icon },
                  { condition: iconTheme, trueClassName: `list-editable_item-icon--${iconTheme}` }
                ])} /> : null}
                <div className='list-editable_item-label'>{label}</div>
              </div>
              <i className='list-editable_item-delete q4i-close-4pt' onClick={() => onDelete(item)} />
            </div>
          )
        })}
      </div>
    )
  }
}

ListEditable.propTypes = {
  theme: PropTypes.oneOf([THEMES.LIGHT_GREY, THEMES.WHITES]),
  icon: PropTypes.string,
  iconTheme: PropTypes.string,
  listKey: PropTypes.string,
  items: PropTypes.array,
  onDelete: PropTypes.func
}

ListEditable.defaultProps = {
  values: [],
  theme: THEMES.LIGHT_GREY
}

export default ListEditable
